import React from 'react';

import SmoothScrollWrapper from '../../utils/SmoothScrollWrapper';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer';

import style from './ErrorPage.module.css';

function ErrorPage() {
  return (
    <>
      <Header isOtherPage />
      <SmoothScrollWrapper>
        <div className={style.ErrorPage}>
          <div className={style.text}>
            <div>Ошибка 404</div>
            <div>Такой страницы не существует</div>
          </div>
          {/* <div className={style.text}>Перейти на главную</div> */}
        </div>
        <Footer isOtherPage />
      </SmoothScrollWrapper>
    </>
  );
}

export default ErrorPage;
